// extracted by mini-css-extract-plugin
var _1 = "CheckBox-module_checkbox__yNb2Al";
var _2 = "CheckBox-module_checkbox_required__oMUnyO";
export { _1 as "checkbox", _2 as "checkbox_required" }
